import { render, staticRenderFns } from "./PreparationForm.vue?vue&type=template&id=2ca9a9f6&scoped=true"
import script from "./PreparationForm.vue?vue&type=script&lang=js"
export * from "./PreparationForm.vue?vue&type=script&lang=js"
import style0 from "./PreparationForm.vue?vue&type=style&index=0&id=2ca9a9f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca9a9f6",
  null
  
)

export default component.exports